"use client";

import { useEffect, useState } from "react";

import { useRouter } from "next/navigation";

import { LoginForm, type LoginUser, RESIDENT_ROUTES } from "@pulseprep/shared-ui";
import { toast, useResidentLogin } from "@pulseprep/shared-ui/hooks";

import { residentAuthStore } from "@/app/_libs/stores/resident-auth.store";

export function LoginPageClient() {
  const router = useRouter();
  const { residentLogin, isLoading } = useResidentLogin();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    residentAuthStore.clear();
  }, []);

  const handleSuccess = (user: LoginUser) => {
    setIsRedirecting(true);
    residentAuthStore.setAuth(user.roles[0] ?? "resident");
    const profile = user as LoginUser & {
      id: string;
      email: string;
      firstName?: string | null;
      lastName?: string | null;
      countryCode?: string | null;
    };
    residentAuthStore.setUser({
      id: profile.id,
      email: profile.email,
      firstName: profile.firstName ?? null,
      lastName: profile.lastName ?? null,
      countryCode: profile.countryCode ?? null,
    });
    toast.success("Welcome back! It's good to see you again.");
    router.replace(RESIDENT_ROUTES.dashboard);
  };

  return (
    <LoginForm
      loginFn={residentLogin}
      isLoading={isLoading || isRedirecting}
      onSuccess={handleSuccess}
      headingTitle="Welcome back!"
      emailPlaceholder="resident@pulseprep.com"
      headingSubtitle="Sign in to continue with your account"
      showSignup={true}
    />
  );
}
